import { server } from "@/api";

export const paginate = async (params) => {
    return await server().get('api/tickets', { params });
}

export const show = async (id) => {
    return await server().get(`api/tickets/${id}`);
}

export const reply = async (id, payload) => {
    return await server().post(`api/tickets/${id}/reply`, payload);
}

export const updateStatus = async (id, status) => {
    return await server().post(`api/tickets/${id}/status`, { status });
}

export const openCount = async () => {
    return await server().get('api/tickets/open-count');
}

export default { paginate, show, reply, updateStatus, openCount };
